import { useEffect, useState } from "react";
import { api, formatTime } from "@/lib/api";

export const SlotPicker = ({ clinic, date, value, onChange, refreshKey = 0 }) => {
  const [slots, setSlots] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [retry, setRetry] = useState(0);

  useEffect(() => {
    setSlots([]);
    setError(false);
    if (!clinic || !date) return undefined;
    let stale = false;
    setLoading(true);
    api.get("/slots", { params: { clinic, date } })
      .then((r) => { if (!stale) setSlots(r.data.slots); })
      .catch(() => { if (!stale) setError(true); })
      .finally(() => { if (!stale) setLoading(false); });
    return () => { stale = true; };
  }, [clinic, date, refreshKey, retry]);

  if (!clinic) return <p className="text-sm text-muted-foreground" data-testid="slot-hint">Please choose a clinic first to see available time slots.</p>;
  if (!date) return <p className="text-sm text-muted-foreground" data-testid="slot-hint">Please pick a date to see available time slots.</p>;
  if (loading) return <p className="text-sm text-muted-foreground" data-testid="slot-loading">Checking availability…</p>;
  if (error) return (
    <p className="text-sm text-destructive" data-testid="slot-error">
      Couldn't load available times.{" "}
      <button type="button" className="font-semibold underline" onClick={() => setRetry((n) => n + 1)} data-testid="slot-retry-btn">Tap to retry</button>
    </p>
  );
  if (!slots.length) return <p className="text-sm text-muted-foreground" data-testid="slot-empty">The doctor is not available here on this day.</p>;

  return (
    <div className="flex flex-wrap gap-2" data-testid="slot-list">
      {slots.map((s) => (
        <button
          type="button"
          key={s.time}
          disabled={!s.available}
          onClick={() => onChange(s.time)}
          data-testid={`slot-${s.time.replace(":", "")}`}
          className={`px-4 py-2 rounded-full text-sm border transition-colors ${value === s.time ? "bg-primary text-white border-primary" : s.available ? "bg-white border-slate-200 hover:border-secondary hover:text-primary" : "bg-slate-50 text-slate-300 border-slate-100 line-through cursor-not-allowed"}`}
        >
          {formatTime(s.time)}
        </button>
      ))}
    </div>
  );
};
